import { render, staticRenderFns } from "./KampusMerdeka.vue?vue&type=template&id=924a3330"
import script from "./KampusMerdeka.vue?vue&type=script&lang=js"
export * from "./KampusMerdeka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports